
export const projectdata=[
        {
            title:"Covid19 Tracker Using React",
            description:"A Covid Tracker that gives information about infected,recovered and deaths until today along with graphs",
            loc:"https://covid19tracker-aathira.netlify.app/"
        },
        {
            title:"Facial Expression Recogition with Keras & Flask",
            description:"A Deep Learning Model that recognises 7 facial expressions on the video camera",
            loc:"https://github.com/Aathira123/Facial-Expression-Recognition-using-Keras"
        },
        {
        title:"Movie Search DataBase",
        description:"A React Web Application to search for movies and get its reviews and rating",
        loc:"https://github.com/Aathira123/MovieSearchDatabase"
        },
        {
            title:"YouTube Clone",
            description:"A simple Youtube Clone that renders the searched video and provides similiar suggestions on the side",
            loc:"https://github.com/Aathira123/Youtube-Clone"
           
        },
 
                {
                    title:"Real Time Chat Application",
                    description:"A client server based chat application with React in the front end , Node and Express to develop server side and socket.io for communication between them",
                loc:"https://github.com/Aathira123/RealtimechatApp"    
                },
                    {
                        title:"Progressive Weather App",
                        description:"A progressive web application to see weather",
                        loc:"https://weatherapp-aathira.netlify.app/"
                        },{
                            loc:"https://github.com/Aathira123/WPL-Project/tree/develop",
                            title:"Hotel Reservation App",
                            description:"A web application similiar to Airbnb done as part of coursework"

                        },
                   {
                    loc:"https://github.com/Aathira123/MachineLearningCS6363",
                    title:"Netflix stock price prediction using LSTM",
                    description:"A deep learning model using LSTM coded from scratch to predict stock price done as part of coursework"
                   }     
    ]


